import { Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import { trigger, transition, style, animate, state, query, stagger, keyframes, AnimationBuilder} from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';

import { LayoutService } from '../services/util/layout.service';
import { ContextService } from '../services/context/context.service';
import { ClientsService } from '../services/clients.service';
import { AccountsService } from '../services/accounts.service';

import { GoalAnalysisService } from '../services/goal-analysis.service';

import { AppMonitoringService } from '../services/util/app-monitoring.service';
import * as fromModel from '../services/models/';
import { MatDialog } from '@angular/material/dialog';
import { CreatePlanComponent } from '../create-plan/create-plan.component';
import { SavePlanComponent } from '../context-components/save-plan/save-plan.component';

import { Subscription } from 'rxjs';
import { ReferenceService } from '../services/reference/reference.service';
import { UIStateService } from '../services/context/uistate.service';
import { ChartDataService } from '../services/context/chart-data.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { GPSnackBarComponent } from '../common/gp-snack-bar/gp-snack-bar.component';
import { Constant } from '../../environments/constants';
//import { PlanService } from '../services/plan.service';
import { DataService } from '../services/context/data.service';

export const easing = {
  standard: 'cubic-bezier(0.4, 0.0, 0.2, 1.0)',
  enter: 'cubic-bezier(0.0, 0.0, 0.2, 1.0)',
  leave: 'cubic-bezier(0.4, 0.0, 1.0, 1.0)'
};

@Component({
  selector: 'gp-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss'],
  animations: [
    trigger('AnimateFooterStagger', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), {optional: true}),
        query(':enter', stagger('100ms', [
          animate('1s ease-in', keyframes([
          style({opacity: 0, transform: 'translateX(-75px)', offset:0}),
          style({opacity: .5, transform: 'translateX(35px)', offset:0.3}),
          style({opacity: 1, transform: 'translateX(0)', offset:1})
          ]))
        ]), {optional: true})
      ])
    ]),
    trigger('AnimateContentFadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(0)' }),
        animate('600ms', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('100ms', style({ opacity: 0, transform: 'translateX(0)' })),
      ])
    ]),

    trigger('AnimateContentFadeInOut1', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('300ms', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('300ms', style({ opacity: 0, transform: 'translateY(0)' })),
      ])
    ]),
    
    trigger('enabledStateChange', [
      state(
        'default',
        style({
          opacity: 1,
        })
      ),
      state(
        'disabled',
        style({
          opacity: 0.5,
        })
      ),
      transition('* => *', animate('300ms ease-out')),
    ]),

    trigger('fadeSlideGrowKeyframe', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.5) translateY(50px)' }),
        animate(
          '500ms',
          keyframes([
            style({ opacity: 1, offset: 0.3 }),
            style({ transform: 'translateY(0)', offset: 0.6 }),
            style({ transform: 'scale(1)', offset: 1 }),
          ])
        ),
      ]),
    ]),

    trigger('ShowHideSettings', [
      transition(':enter', [
        style({ transform: 'translateX(0%)'}),
        animate('150ms', keyframes([
          style({opacity: 0, transform: 'translateX(100%)', offset: 0}),
          style({opacity: 0.5, transform: 'translateX(-50px)', offset: 0.3}),
          style({opacity: 1, transform: 'translateX(0)', offset: 1})
        ]))
      ]),
      transition(':leave', [
        animate('300ms', keyframes([
          style({opacity: 1, transform: 'translateX(0)', offset: 0}),
          style({opacity: 0.5, transform: 'translateX(-50px)', offset: 0.3}),
          style({opacity: 0, transform: 'translateX(100%)', offset: 1})
        ]))
      ])
    ]),

    // trigger('fadeSlideInOut', [
    //   transition(':enter', [
    //     style({ opacity: 0, transform: 'translateY(0)' }),
    //     animate('500ms', style({ opacity: 1, transform: 'translateY(0)' })),
    //   ]),
    //   transition(':leave', [
    //     animate('500ms', style({ opacity: 0, transform: 'translateY(0)' })),
    //   ]),
    // ]),


    // trigger('changeQuote', [
    //   state('true', style({
    //     opacity: '1'
    //   })),
    //   state('false', style({
    //     opacity: '0'
    //   })),
    //   transition('0 <=> 1', animate('1000ms ease'))
    // ])
  ]
  
})
export class PlanComponent implements OnInit, OnDestroy {

  resultSections;  
  selectedResultSection;

  results;
  selectedResult;
  
  subResults;
  selectedSubResult;
  
  componentType: fromModel.COMPONENTTYPES;
  
  footerExpanded = false; 
  
  subscriptionLayout: Subscription;
  protected _storeAppContextSubscription: Subscription;
  protected _storeDataSubscription: Subscription;
  protected _uiStateSubscription: Subscription;
  
  plan: fromModel.PlanClient;
  clientId;
  clientName;
  planId;
  planName;
  showContentAnimation = true;
  showHeaderAnimation = true;
  showBoxAnimation = false;

  showProgress = false;

  showSettings = false;
  //isPlanDirty = false;

  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  // saveId;
  // side;

  @ViewChild('mainSection') mainEl: ElementRef;
  @ViewChild('animationBoxEl') el1: ElementRef;
  
  
  constructor(private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog, 
    private _snackBar: MatSnackBar,
    private appMonitoringService: AppMonitoringService,
    private layoutService: LayoutService,
    private referenceService: ReferenceService,
    private contextService: ContextService,
    private dataService: DataService,
    private uiStateService: UIStateService,  
    private chartDataService: ChartDataService,
    private clientsService: ClientsService,
    private accountsService: AccountsService,
    //private planService: PlanService,
    private goalAnalysisService: GoalAnalysisService,
    private builder: AnimationBuilder) {  
      this._storeAppContextSubscription = this.contextService.subscribe((appContext: fromModel.IAppContext) => this.populateAppContext(appContext));
      this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
      this._uiStateSubscription =  this.uiStateService.subscribe((uiState: fromModel.IUIState) => this.populateUIContext(uiState));     
  }

  ngOnInit(): void {

    this.initalizeApp();       
    
    this.route.paramMap.subscribe(params => {      
      this.planId = params.get('id');      
      if(this.planId && this.planId.trim()){
        //load plan based on planId and also load client context
        this.openPlan();
      } else {        
        this.route.queryParamMap.subscribe(queryParams => {            
          
          this.clientId = queryParams.get('cid');          

          if(this.clientId && this.clientId.trim() && !this.contextService.context.LegalEntityID.trim()){            
              this.createPlan(this.clientId);
            } else {            
            //go back to Home page   
            //this.router.navigate(['/home'], {queryParams: {email: loginEmail, uid: uid}});   
            this.router.navigate(['/home']);   
          }
        }, err=>{
          console.log("Error reading query parameter (cid) in plan route");      
          this.appMonitoringService.traceMsg("Error: Error reading query parameter (cid) in plan route", JSON.stringify(err), 'Error');
        });
      }
    }, err=>{
      console.log("Error reading query parameter (planId) in plan route");      
      this.appMonitoringService.traceMsg("Error: Error reading query parameter (planId) in plan route", JSON.stringify(err) , 'Error');
    });    
  }

  populateAppContext(appContext: fromModel.IAppContext){        
    this.showClientPlanName();
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action !== fromModel.DATA_ACTION.NONE){      

      if(appData.action === fromModel.DATA_ACTION.PLAN && appData.Plan && !appData.Plan['Error']){
        //this.goalAnalysisService.getGoalAnalysis(appData.Plan, this.dataService);        
        this.dataService.getGoalSummary();
        this.dataService.getPlanAnalysis();   
        
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "PlanComponent-populateAppData", false);

      } else if(appData.action === fromModel.DATA_ACTION.INFLIGHTPLAN && appData.Plan && !appData.Plan['Error']){ 
        this.dataService.savePlan();
        this.dataService.setClientInContext();
        // this.goalAnalysisService.getGoalAnalysis(appData.Plan, this.dataService);        
        this.dataService.getGoalSummary();
        this.dataService.getPlanAnalysis();
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "PlanComponent-populateAppData", false);

      } else if(appData.Plan && appData.Plan['Error']){
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "PlanComponent-populateAppData", false);
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "PlanComponent-populateAppData", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.systemErrorMsg});
      } else if(appData.action === fromModel.DATA_ACTION.PLANIDNAME && !appData.Plan.planSaveError) {
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "PlanComponent-populateAppData", {ShowMsg: true, MsgType: fromModel.MSGTYPE.SUCCESS, Msg: Constant.InfoMsgs.saveSuccess});
      } else if(appData.action === fromModel.DATA_ACTION.PLANIDNAME && appData.Plan.planSaveError) {
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "PlanComponent-populateAppData", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.saveFailure});
      }
    }
  }

  populateUIContext(uiState: fromModel.IUIState){     
    if(uiState){
        this.showProgress = uiState.ShowProgressBar;
        if(uiState.action == fromModel.UI_STATE_ACTION.SHOWERRORMSG && uiState.ShowMsg){          
          this.showSystemErrorMsg(uiState.MsgType, uiState.Msg);          
          //this.showSystemErrorMsg(fromModel.MSGTYPE.SUCCESS, uiState.Msg);          
        }      
        // if(uiState.action == fromModel.UI_STATE_ACTION.PLANDIRTY){
        //   this.isPlanDirty =  uiState.IsPlanDirty;
        // }
    }
  }

  openPlan(){ //Open Plan Workflow
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "PlanComponent-openPlan", true);
    //this.planService.getPlanDetails(this.planId);  
    this.dataService.setPlanInContext(this.planId);  }

  createPlan(cid){ //Create Plan Workflow
    this.clientsService.getClientAPI([cid]).subscribe(client=>{
      if(client && client['value'] && client['value'].length>0){
        if((client['value'][0].Account && client['value'][0].Account.length>0) || (client['value'][0].externalAccounts && client['value'][0].externalAccounts.length>0)){       
          let allAccountIds = [];

          if(client['value'][0].Account){
          client['value'][0].Account.forEach(acc => {
              allAccountIds.push(acc);  
            });    
          }         
          if(client['value'][0].externalAccounts){
            client['value'][0].externalAccounts.forEach(extAcc => {
              allAccountIds.push(extAcc.accountId);   
            });    
          }                  
          this.accountsService.getAccountsAPI(allAccountIds).subscribe(accounts=>{
            let accs = [];
            let lbs = [];
            if(accounts && accounts['value'] && accounts['value'].length>0){
              accounts['value'] .forEach(acc => {
                if(acc.registrationtype==="LB"){
                  lbs.push(acc);                  
                } else {
                  accs.push(acc);                  
                }                
              });
              this.contextService.dispatchAction(fromModel.APP_ACTION.CLIENT,"Plan Component - createPlan", {client: client['value'][0], accounts: accs, liabilities: lbs});                
              //this.contextService.dispatchAction(fromModel.APP_ACTION.CLIENT,"Plan Component - createPlan", client['value'][0]);                
              this.openModelDialog(fromModel.OPENDIALOGACTIONS.CREATEPLAN);        
            }
          }, err=>{
            console.log("Error getting clients data from Plan Dashboard: Client Id" + cid + JSON.stringify(err));      
            this.appMonitoringService.traceMsg("Error: Error getting clients data from Plan Dashboard: Client Id: ", cid + JSON.stringify(err), 'Error');
          });
        }
        else {
          this.contextService.dispatchAction(fromModel.APP_ACTION.CLIENT,"Plan Component - createPlan", {client: client['value'][0], accounts: null, liabilities: null});              
          this.openModelDialog(fromModel.OPENDIALOGACTIONS.CREATEPLAN);    
        }
      }
    }, err=>{
      console.log("Error getting clients data from Plan Dashboard: Client Id" + cid + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error: Error getting clients data from Plan Dashboard: Client Id: ", cid + JSON.stringify(err), 'Error');
    });
  }

  createPlanBackup(cid){ //Create Plan Workflow
    this.clientsService.getClientAPI([cid]).subscribe(client=>{
      if(client && client['value'] && client['value'].length>0){
        this.contextService.dispatchAction(fromModel.APP_ACTION.CLIENT,"Plan Component - createPlan", client['value'][0]);    
        //this.showClientPlanName();        
        this.openModelDialog(fromModel.OPENDIALOGACTIONS.CREATEPLAN);        
      }
    }, err=>{
      console.log("Error getting clients data from Plan Dashboard: Client Id" + cid + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error: Error getting clients data from Plan Dashboard: Client Id: ", cid + JSON.stringify(err), 'Error');
    });
  }

  selectResultSection(resultSec){
    
    this.selectedResultSection = resultSec;
    this.results = this.selectedResultSection.results;
    this.selectResult(this.results[0]);  

    //this.startContentLoadingAnimation();
        
  }

  onSideNavClick(side){    
    let index = this.results.findIndex(res => res.id === this.selectedResult.id);
    if(side === 'left'){
      if(index>0){
        this.selectResult(this.results[index-1],'sidenav');
      }
    } else {
      if(index>=0 && index<this.results.length-1){
        this.selectResult(this.results[index+1], 'sidenav');
      }
    }
  }

  // onSideNavClick(side){  
  //   this.saveId = Utils.newGuid();  
  //   this.side = side;
  // }

  // loadResult(){

  //   let index = this.results.findIndex(res => res.id === this.selectedResult.id);
  //   if(this.side === 'left'){
  //     if(index>0){
  //       this.selectResult(this.results[index-1],'sidenav');
  //     }
  //   } else {
  //     if(index>=0 && index<this.results.length-1){
  //       this.selectResult(this.results[index+1], 'sidenav');
  //     }
  //   }

  // }

  selectResult(result, from?){
    this.selectedResult = result;    
    //this.loadResultContent(this.selectedResult.id, from);  
    if(result.subresults){
      this.subResults = result.subresults;
      this.selectedSubResult = this.subResults[0];
      this.loadResultContent(this.selectedSubResult.id, from);    
    } else {
      this.subResults = null;
      this.selectedSubResult = null;
      this.loadResultContent(this.selectedResult.id, from);
    }

    
  }

  

   selectSubResult(subResult){
     this.selectedSubResult = subResult;
     this.loadResultContent(subResult.id);
   }

  loadResultContent(comType, from?){
    if(from === 'headernav' || from === 'sidenav'){
      this.loadResultContentWithAnimation(comType);        
    } else {
      this.componentType = comType;  
    }  
  } 

  loadResultContentWithAnimation(comType){
    this.showContentAnimation = false;
    setTimeout(() => {
    this.componentType = comType;
    this.showContentAnimation = true;  
    }, 100);  
  }

  startContentLoadingAnimation() {
    this.showContentAnimation = false;
    this.showHeaderAnimation = false;
    this.showBoxAnimation = true;
    setTimeout(() => {
      if(this.el1 && this.el1.nativeElement) {
        
        const stepsNumber = 30;

        const baseNumberForExpoFn = Math.pow(stepsNumber, 1/stepsNumber);
        
        const currentWidth = this.el1.nativeElement.offsetWidth;
        const  currentHeight = this.el1.nativeElement.offsetHeight;
      
        const availableWidth = this.mainEl.nativeElement.offsetWidth;
        const availableHeight = this.mainEl.nativeElement.offsetHeight;

        let scaleX = availableWidth / currentWidth;
        let scaleY = availableHeight / currentHeight;

        // scaleX = Math.min(scaleX, scaleY);
        // scaleY = scaleX;
        
        const translationX = Math.round((availableWidth - (currentWidth * scaleX)) / 2);
        const translationY = Math.round((availableHeight - (currentHeight * scaleY)) / 2);


        const steps = Array(stepsNumber)
        .fill(null)
        .map((e, i) => i + 1)
        .map( (x, i, arr) => {;

          console.log("x: " + x);
          let y = Math.pow(baseNumberForExpoFn, x);
          console.log("baseNumberForExpoFn: " + baseNumberForExpoFn);
          console.log("y: " + y);

          scaleX = x;
          scaleY = y;
            
          
          const transform = style({
            transform: `translate(${y}vw, -${x}vh) scale(${i/6.2}, ${i/8})`,                    
          })

          return transform;
        });

        console.log(steps);
        console.log("width: " + this.mainEl.nativeElement.offsetWidth);
        console.log("height: " + this.mainEl.nativeElement.offsetHeight);

          // steps.push(style({
          //   height: '100%',
          //   width: 'fit-content'
          // }));

        steps.push(style({
          width: 450 + 'px',
          height: 250 + 'px',
          transition:  '1s ease-in-out'
          //transform: `translate(400px, -${scaleY}vh) scale(6, 3.0)`,     
        }));
        

        let keyFrame = keyframes(steps);
        //.build([query(':enter', style({ opacity: 0 }), {optional: true}), query(':enter', stagger('100ms', [animate(`700ms ${easing.enter}`, keyFrame)]), {optional: true})])

        // this.builder
        //   .build(animate(`700ms ${easing.enter}`, keyFrame))
        //   .create(this.el.nativeElement)
        //   .play();


        this.builder
        .build(animate(`900ms ${easing.enter}`, keyFrame))
        .create(this.el1.nativeElement)
        .play();

        // this.builder
        // .build(animate(`700ms ${easing.enter}`, keyFrame))
        // .create(this.el2.nativeElement)
        // .play();

        // this.builder
        // .build(animate(`700ms ${easing.enter}`, keyFrame))
        // .create(this.el3.nativeElement)
        // .play();

        // this.builder
        // .build(animate(`700ms ${easing.enter}`, keyFrame))
        // .create(this.el4.nativeElement)
        // .play();
        


        

          setTimeout(() => {
            // this.builder
            // .build(animate(`700ms ${easing.enter}`, style({
            //   transform: `scale(3)`     
            // })))
            // .create(this.el.nativeElement)
            // .play();
            this.showBoxAnimation = false;  
            this.showContentAnimation = true;
            this.showHeaderAnimation = true;
          }, 1000);


          // trigger('ShowTemplates', [
          // transition('* => *', [
          //   query(':enter', style({ opacity: 0 }), {optional: true}),
          //   query(':enter', stagger('100ms', [
          //     animate('1s ease-in', keyframes([
          //     style({opacity: 0, transform: 'translateX(-75px)', offset:0}),
          //     style({opacity: .5, transform: 'translateX(35px)', offset:0.3}),
          //     style({opacity: 1, transform: 'translateX(0)', offset:1})
          //     ]))
          //   ]), {optional: true})
          // ])
        
      }
    }, 10);
  }

  savePlan(){
    if(!this.planId.trim()) {
      this.openModelDialog(fromModel.OPENDIALOGACTIONS.SAVEPLAN);    
    } else {
      //this.planService.savePlan(this.dataService.appData.Plan);
      this.dataService.savePlan();
    }
  }

  editPlan(){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.SAVEPLAN);    
  }
  
  ngOnDestroy(): void{
    if(this._storeAppContextSubscription && this._storeAppContextSubscription !== null){
      this._storeAppContextSubscription.unsubscribe();
    }
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
    if(this._uiStateSubscription && this._uiStateSubscription !== null){
      this._uiStateSubscription.unsubscribe();    
    }
  }

  initalizeApp() {

    this.gptReset();

    this.referenceService.getResultRefrenceData().subscribe(resultSecs=>{
      this.resultSections = resultSecs;
      this.selectResultSection(this.resultSections[1]); // Default Goals Tab     
    })

    this.subscriptionLayout = this.layoutService.screenSize.subscribe(size => {
      if(size === 'SM'){
        this.footerExpanded = false;
      }
    });
    //this.showClientPlanName();    
  } 

  gptReset(){
    this.contextService.dispatchAction(fromModel.APP_ACTION.RESET, "PlanComponent - gptReset", null);
    this.dataService.dispatchAction(fromModel.DATA_ACTION.RESET, "PlanComponent - gptReset", null);    
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.RESET, "PlanComponent - gptReset", null);     
    this.chartDataService.dispatchAction(fromModel.CHART_DATA_ACTION.RESET, "PlanComponent - gptReset", null);     
    this.goalAnalysisService.goalAnalysisDataObservable = null;
    //this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.STATEEXP, "PlanComponent - gptReset", null);
  } 

  showClientPlanName(){
    if(this.contextService && this.contextService.context){
      this.clientId = this.contextService.context.LegalEntityID;
      if(this.clientId.trim()){
        this.clientName = this.contextService.context.LegalEntityName;
      }
      this.planId = this.contextService.context.PlanId;
      if(this.planId.trim()){
        this.planName = this.contextService.context.PlanName;
      }
      
    }
  }


  openSnackBar(msg,msgType){
    let styleClass;
    switch(msgType){
      case fromModel.MSGTYPE.INFO: 
       styleClass = "infoMsg";
       break;
      case fromModel.MSGTYPE.WARNING: 
       styleClass = "warningMsg";
       break;
      case fromModel.MSGTYPE.ERROR: 
       styleClass = "errorMsg";
       break;
      case fromModel.MSGTYPE.SUCCESS: 
       styleClass = "successMsg";
       break;
    }
    this._snackBar.openFromComponent(GPSnackBarComponent, {
      data: {
        message: msg,
        type: msgType,
      }, 
      duration: 2000,
      panelClass: [styleClass],
      horizontalPosition: this.horizontalPosition,     
      verticalPosition: this.verticalPosition
      });
  }

  showSystemErrorMsg(msgType: fromModel.MSGTYPE, msg?: string) {
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG,"PlanComponent-showSystemErrorMsg", false);
    if(!msg){
      msg = Constant.ErrorMsgs.systemErrorMsg;
    }
    this.openSnackBar(msg, msgType);        
  } 

  showHideSettings(){        
    this.showSettings = !this.showSettings;
  }

  footerExpandCollapse(){
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.REFRESH, "PlanComponent-footerExpandCollapse", true);        
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.CREATEPLAN: {
        const dialogRef = this.dialog.open(CreatePlanComponent, {
          width: '80%',
          height: '80%',
          //data: this.inFlightplan,
          disableClose: true    
          }).afterClosed()
          .subscribe(inFlightPlan => {
            if(inFlightPlan){
              //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "PlanComponent-openModelDialog(OPENDIALOGACTIONS.CREATEPLAN)", true);
              //this.goalAnalysisService.getGoalAnalysis(inFlightPlan);    
            }
          });        
        break;
      } 
      case fromModel.OPENDIALOGACTIONS.SAVEPLAN: {
        const dialogRef = this.dialog.open(SavePlanComponent, {
          width: '550px',
          height: '250px',
          disableClose: true  
          //data: { documentType: documentType, documentName: this.documentName, defaultProposalName: `Proposal for ${this.clientName}`}                  
        });
        break;
      }           
    }
  }
}



// showSystemErrorMsg(msgType: fromModel.MSGTYPE, msg?: string) {
//   this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG,"PlanComponent-showSystemErrorMsg", false);
//   if(!msg){
//     msg = Constant.ErrorMsgs.systemErrorMsg;
//   }
//   switch(msgType){
//     case fromModel.MSGTYPE.INFO: 
//       this._snackBar.open(msg, 'X', {
//         duration: 3000,
//         panelClass: ['infoMsg'],
//         horizontalPosition: this.horizontalPosition,     
//         verticalPosition: this.verticalPosition,
//       }); 
//       break;
//     case fromModel.MSGTYPE.WARNING: 
//     this._snackBar.open(msg, 'X', {
//       duration: 3000,
//       panelClass: ['warningMsg'],
//       horizontalPosition: this.horizontalPosition,     
//       verticalPosition: this.verticalPosition,
//     }); 
//     break;
//     case fromModel.MSGTYPE.ERROR: 
//       this._snackBar.open(msg, 'X', {
//         duration: 3000,
//         panelClass: ['errorMsg'],
//         horizontalPosition: this.horizontalPosition,     
//         verticalPosition: this.verticalPosition,
//       });        
//       break;      
//     // case fromModel.MSGTYPE.SUCCESS: 
//     //   msg =  "<mat-icon>settings</mat-icon>" + msg;
//     //   this._snackBar.open(msg, 'X', {
//     //     duration: 3000,
//     //     panelClass: ['successMsg'],
//     //     horizontalPosition: this.horizontalPosition,     
//     //     verticalPosition: this.verticalPosition,
//     //   });        
//     //   break;

//     case fromModel.MSGTYPE.SUCCESS: 
//     this._snackBar.openFromComponent(GPSnackBarComponent, {
//       data: {
//         message: msg,
//         type: fromModel.MSGTYPE.SUCCESS,
//       //  icon: 'check_circle'  //check_circle, warning, error, info
//       }, 
//       duration: 3000,
//       panelClass: ['successMsg'],
//       horizontalPosition: this.horizontalPosition,     
//       verticalPosition: this.verticalPosition
//     });
//       break;
//   }    
// } 